package com.essntl.features.proposal.ui.allproposal

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalFilterOptions
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.request.domain.model.RequestModel

data class AllProposalState(
    val getAllProposal: PaginationState<ProposalModel> = PaginationState(),
    val filterOptions: ProposalFilterOptions = ProposalFilterOptions(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getAllRequest: State<List<RequestModel>> = State(),
    val getAllProfile: State<List<ProfileModel>> = State(),
    val addEditProposal: State<ProposalModel> = State(),

    // String is proposalId
    val getAllProposalHistoryMap: Map<String, State<List<ProposalModel>>> = emptyMap(),

    val selectedProposalId: String = "",

    val updateProposalLoading: List<String> = emptyList(),
    val updateProposalOwnerLoading: List<String> = emptyList(),
)